import { dynamicWrapper, createRoute } from '@/utils/core';
const routesConfig = app => ({
  path: '/management/resubmitOrder',
  key: 'management.resubmit',
  title: 'Resubmit Order',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});
export default app => createRoute(app, routesConfig);
